<template>
    <div class="wh100">
	    <xh-filter-layout :title="title">
	        <template slot="filter">
	            <el-form :inline="true" size="medium">
	                <el-form-item>
	                    <el-input v-model="form.news_title" placeholder="请输入标题" clearable></el-input>
	                </el-form-item>
					<el-form-item>
                        <el-select v-model="form.model_item" filterable placeholder="模块栏目" style="width:110px" clearable>
                            <el-option v-for="item in modelitemlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
	               <el-form-item>
                        <el-date-picker v-model="form.publish_time" type="date" value-format="yyyy-MM-dd" placeholder="发布日期"></el-date-picker>
                    </el-form-item>
	                <el-form-item>
	                    <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
	                </el-form-item>
	                <el-form-item>
	                    <el-button class="" type="primary" @click="reset()">重置</el-button>
	                </el-form-item>
	                <el-form-item>
	                    <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
	                </el-form-item>
	                <el-form-item>
	                    <el-button class="el-icon-delete" type="primary" @click="deleteNews()">删除</el-button>
	                </el-form-item>
	            </el-form>
	        </template>
	        <template #content>
	            <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true" >
	                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
	                <el-table-column prop="news_title" label="新闻标题" align="center" sortable></el-table-column>
					<el-table-column prop="modelItemName" label="模块栏目" align="center" width="140" sortable></el-table-column>
					<el-table-column prop="	is_broadcast" label="是否轮播" align="center" width="140" sortable>
						<template slot-scope="scope">
							{{scope.row.is_broadcast==1?"是":"否"}}
						</template>
					</el-table-column>
					<el-table-column prop="is_open_url" label="是否直接打开URL" align="center" width="140" sortable>
						<template slot-scope="scope">
							{{scope.row.is_open_url=="1"?"是":"否"}}
						</template>
					</el-table-column>
					<el-table-column prop="is_open_attachment" label="是否直接打开附件" align="center" width="140" sortable>
						<template slot-scope="scope">
							{{scope.row.is_open_attachment=="1"?"是":"否"}}
						</template>
					</el-table-column>
					<el-table-column prop="publish_time" label="发布时间" align="center" width="140" sortable></el-table-column>
	                <el-table-column prop="publish_account" label="发布人" align="center" width="140" sortable></el-table-column>
					<el-table-column label="操作" align="center" width="100">
						<template slot-scope="scope">
							<el-tooltip effect="dark" content="修改" placement="top">
								<el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
							</el-tooltip>
							<el-tooltip effect="dark" content="删除" placement="top">
								<el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteNews(scope.row)"></el-button>
							</el-tooltip>
						</template>
	                </el-table-column>
				</MyTable>
	        </template>
	    </xh-filter-layout>
	    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="80%" height="90%" :close-on-click-modal="false" @closed="closeModal">
	        <NewsEdit ref="editRef" :key="timer" :data="dialog.editRow" @closeModal="closeModal" center></NewsEdit>
	    </xh-dialog>
	</div>
</template>

<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import NewsEdit from "./components/NewsEdit";
export default {
  name: "NewsTrends",
  components: { XhFilterLayout, MyPanel, MyTable,NewsEdit},
  data(){
	return{
		title:'党务建设',
		form: {
			news_title: "",
			publish_time: "",
			model_item: null,
			news_model:"PartyType",
        },
		table: {
			method: "POST",
			url: "/newsCenter/getNewsCenterPage",
			pageSize: 50,
        },
		checkRowId: [],
		timer:"",
		dialog: {
			title: "添加",
			visible: false,
			editRow: {}
		},
		modelitemlist:[{value:"PT01",label:"党建工作"},{value:"PT02",label:"党建文化"},{value:"PT03",label:"社会责任"},{value:"PT04",label:"党建活动"}],
	}
  },
  methods:{
	reset() {
		this.form.news_title = "";
		this.form.publish_time = "";
		this.form.model_item = null;
	},
	query(){
		this.$refs.mytable.reload();
    },
	edit(row) {
		let that = this;
		that.timer = new Date().getTime();
		if (row == null) {
			that.dialog.title = "添加";
			that.dialog.editRow = {
				id: that.$util.guid(),
				news_title: null,
				news_subtitle: null,
				news_model: "PartyType",
				model_item: null,
				news_source:"",
				news_content:"",
				publish_time:"",
				is_show_index:"0",
				is_broadcast:"",
				is_open_attachment:"0",
				url:"",
				is_show_main:"0",
				is_open_url:"0",
				publish_account: that.$store.state.userInfo.account,
				publish_user_name: that.$store.state.userInfo.usercname,
				remark:"",
				att_list:null,
				att_list0:null
			};
		} else {
			row.isView = false;
			that.dialog.title = "修改";
			that.dialog.editRow = row;
		}
	
		that.dialog.visible = true;
	},
	deleteNews(row){
				let that = this;
			
				that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", {confirmButtonText: "确定",cancelButtonText: "取消",type: "warning"})
					.then(() => {
						that.$api.post("/newsCenter/deleteNews", { id: row.id },
							function (res) {
								if (res.code === "200") {
									that.query();
									that.$message.success("删除成功");
								} else {
									that.$message.error("删除失败");
								}
							},
							function (res) {
								//that.$message.error("服务器异常，删除出错");
							}
						);
					})
					.catch(() => { });
				
			},
	//关闭弹出页面
	closeModal() {
		this.dialog.visible = false;
		this.$nextTick(function () { this.query(); });
		},
    },
	computed: { },
	mounted() { },
	created() { },
	watch: { },
}
</script>

<style scoped>

</style>
